module.exports = __webpack_public_path__ + "static/OP4-b194dcfabc2614d63827994f9113a625.jpg";